import axios from "axios";

//IMPORT API ROUTE URL
import { UPDATE_PROPOSE_JOB_FROM_MATCHING_ROUTE } from "./apiRoutes";

const getUpdateProposeFor = (j_slug, u_id, a_id, r_slug) => {
  var postData = new FormData();

  postData.append("r_slug", r_slug);
  postData.append("j_slug", j_slug);
  postData.append("u_id", u_id);
  postData.append("a_id", a_id);

  return axios
    .post(UPDATE_PROPOSE_JOB_FROM_MATCHING_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getUpdateProposeFor;
